import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { IBulkStatusUpdateItem } from '../../../api/types';

export const useDocumentDataBulkStatusUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (items: IBulkStatusUpdateItem[]) => {
      return await (await glynt).documentData.bulkUpdateStatus(items);
    },

    ...callbacks
  });
};
